<template>
    <el-dialog
            title="开通会员" class="fotoo"
            :visible.sync="dialogVisible"
            width="50%" append-to-body
            :before-close="handleClose">
        <div class="tips">{{user.userName}} / {{user.mobile}}</div>
        <div class="flex-vc" style="padding: 40px">
            <el-date-picker
                    v-model="pickerValue"
                    type="daterange" :editable="false"
                    align="left"
                    range-separator="至" value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions">
            </el-date-picker>
            <div class="button"
                 @click="saveUserType">保存</div>
        </div>

    </el-dialog>
</template>
<script>
  import App from '../../util/comfun'
  const pickerMenuOptions=[
    {text: '1个月', day: 31},
    {text: '3个月', day: 92},
    {text: '半年', day: 183},
    {text: '一年', day: 365},
  ]
  export default {
    props:{
    },
    data () {
      return {
        dialogVisible: false,
        user:{},
        pickerOptions: {
          shortcuts: [{
            text: '1个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '3个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 183);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        pickerValue: ''
      }
    },
    methods:{
      handleClick(){},
      handleClose(done) {
        done();
      },
      show(user){
        this.user=user
        this.setPickerOptions()
        this.dialogVisible=true
      },
      setPickerOptions(){
        let now=new Date()
        if(this.user.vipType==1){
          let endVip=new Date(this.user.endTime*1000)
          if(endVip>now){
            now=endVip
          }
        }
        let shortcuts=[]
        pickerMenuOptions.forEach(opt=>{
          shortcuts.push({
            text: opt.text,
            onClick(picker) {
              const start = new Date(now.getTime());
              const end = new Date(now.getTime());
              end.setTime(end.getTime() + 3600 * 1000 * 24 * opt.day);
              picker.$emit('pick', [start, end]);
            }
          })
        })
        this.pickerOptions.shortcuts=shortcuts
      },
      saveUserType(){
        if(this.pickerValue && this.pickerValue.length>0){
          this.dialogVisible=false
          App.demand('/admin/user/openMember','POST',{
            "createActivityTime": 9999,
            "endTime": this.pickerValue[1],
            "startTime": this.pickerValue[0],
            "userId": this.user.id,
            "vipType": 1
          }).then(res=>{
            this.$emit('event');
          })
        }
      },
    },
    mounted(){

    },
  }
</script>

<style>
    .simple{

    }
    .tips{
        padding-left: 60px;
        height: 25px;
        opacity: 1;
        font-size: 14px;
        font-family: PingFang, PingFang-SC;
        font-weight: SC;
        text-align: left;
        color: #999999;
        line-height: 25px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e0e0e0;
    }
    .button{
        width: 200px;
        height: 40px;
        opacity: 1;
        background: #3dc4a7;
        border-radius: 30px;

        opacity: 1;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        line-height: 40px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;

        margin-top: 60px;
    }
    .source{
        margin-right: 70px;
        position: relative;
    }
    .source-tip{
        position: absolute;
        top:-15px;
        left: 152px;
        min-width: 54px;
        height: 22px;
        opacity: 1;
        background: #ed7b61;
        border-radius: 11px;
        font-size: 12px;
        color: #fefefe;
        display: flex;
        align-items: center;
        text-align: center;
        justify-items: center;
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        white-space:nowrap;
    }
    .source-tip::before{
        position: absolute;
        content: "";
        top:10px;
        left: 0px;
        border-color:  transparent transparent transparent #ED7B61;
        border-width: 10px;
        border-radius: 5px;
        border-style: solid;
    }
    .bg-green{
        background: #3dc4a7;
    }
</style>


// WEBPACK FOOTER //
// src/pages/components/userType.vue